<template>
  <div id="inside" style="">
    <div class="container">
      <div class="row">
        <div class=""></div>
        <div class="btn-group btn-group-sm">
          <a
            href="/"
            class="btn btn-link d-flex flex-column justify-content-center text-secondary"
            ><i class="fa fa-home fa-fw fa-lg"></i
          ></a>
          <router-link to="#"
            ><a
              href="#"
              class="btn btn-link text-secondary"
              style="text-decoration: none; cursor: initial"
              >Acordo Fechado</a
            >
          </router-link>
        </div>
        <div class="col-md-12">
          <h1>Acordo fechado</h1>
          <p class="text-muted">
            Pague os boletos abaixo até as datas de vencimento.
          </p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <p class="text-info mb-0">
            Documento {{ formatDocument(user.DocNumber) }}<br />
          </p>
          <p class="text-info">
            {{
              formatData(
                responseFromAgreement.PRESTACOES.PREST[0].DATVENCI,
                "YYYY-MM-DD",
                "DD/MM/YYYY"
              )
            }}
            <br />
          </p>
        </div>
        <div class="d-inline-flex flex-wrap flex-column col-acao col-lg-6">
          <div
            class="card"
            v-for="(value, key, index) in responseFromAgreement.DADOBOLETO"
            :key="`${key}-${index}`"
          >
            <div class="card-header">
              <i class="fa fa-fw mr-2 fa-circle text-warning"></i>
              Boleto ativo
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 col-12">
                  <!-- <h6 class="">Contrato(s) {{ formatedContracts(value.CONTRATOS) }}</h6> -->
                  <h6>Acordo: {{ responseFromAgreement.CODPARCE }}</h6>
                  <p>
                    {{ value.COMPOSICAO1 + " " + value.COMPOSICAO2 }}
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6 col-6">
                      <p class="m-0 text-info">Valor:</p>
                      <h6>
                        {{
                          formattedValue(
                            responseFromAgreement.PRESTACOES.PREST[key].VALPAGO
                          )
                        }}
                      </h6>
                    </div>
                    <div class="col-md-6 col-6">
                      <p class="m-0 text-info">Vencimento:</p>
                      <h6>
                        {{
                          formatData(
                            responseFromAgreement.PRESTACOES.PREST[key]
                              .DATVENCI,
                            "YYYY-MM-DD",
                            "DD/MM/YYYY"
                          )
                        }}
                      </h6>
                    </div>
                  </div>
                  <p>Parcela - {{ key + 1 }}</p>
                  <hr />
                  <p class="text-info mb-1">Linha digitável:</p>
                  <p class="codebar" id="linhaDigitavel">
                    {{ value.LINHADIGITAVEL }}
                  </p>
                  <button
                    class="btn mr-1 mb-1 btn-outline-primary btn-block"
                    @click="copiarLinhaDigitável(value.LINHADIGITAVEL)"
                    :disabled="loading"
                    ><i
                      class="fa fa-copy fa-fw"
                      @click="copiarLinhaDigitável()"
                    ></i
                    >&nbsp;Copiar linha digitável</button
                  >
                  <button
                    class="btn mr-1 mb-1 btn-outline-primary btn-block"
                    :disabled="loading"
                    @click="generatePDF(value, key + 1)"
                    ><i class="fa fa-download fa-fw"></i>&nbsp;Baixar boleto</button
                  >
                  <button
                    class="btn mr-1 mb-1 btn-outline-primary btn-block"
                    :disabled="loading"
                    @click="sendSms(value.LINHADIGITAVEL)"
                    ><i class="fa fa-fw fa-mobile"></i>&nbsp;Receber por SMS</button
                  >
                  <button
                    class="btn mr-1 mb-1 btn-outline-primary btn-block"
                    :disabled="loading"
                    @click="sendEmail(value.LINHADIGITAVEL)"
                    ><i class="fa fa-fw fa-envelope-o"></i>&nbsp;Receber por
                    e-mail</button
                  >
                  <div
                    class="col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2"
                    style=""
                    v-if="loading"
                  >
                    <ProgressLoading v-bind:loading="loading" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  formatDocument,
  parseBR,
} from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";

export default {
  name: "HistoricoPagamentos",
  components: {
    ProgressLoading
  },
  data() {
    return {
      loadDeal: false,
      // agreement: null,
      contract: null,
      selectDeal: null,
      digitalLine: null,
      contractFull: null,
      checkSelectAll: false,
      checkContract: false,
      links: [],
      responseFromAgreement: {},
      userAdm: {},
      ipUser: null,
      loading: false
    };
  },
  methods: {
    formatValue,
    formatData,
    formatDocument,

    ...mapActions("minhasDividas", ["ActionSendEmailOrSmsText", "ActionLogDownloadBoleto", "ActionLogCopyDigitableLine"]),
    ...mapActions("auth", ["ActionGetIPAddress"]),

    formatedContracts(contracts) {
      const allContracts = contracts.split(";");
      return allContracts.length > 2 ? String(allContracts) : allContracts[0];
    },

    formattedValue(value) {
      return parseBR(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    generatePDF(value, key) {
      const linkSource = `data:application/pdf;base64,${value["BASE64"]}`;
      const downloadLink = document.createElement("a");
      downloadLink.setAttribute("target", "_blank");
      const fileName = `boleto-parcela-${key}.pdf`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      this.ActionLogDownloadBoleto({
        IP: this.ipUser || "",
        OS: typeof navigator !== "undefined" ? navigator.platform : "",
        UserID: this.userAdm ? this.userAdm.UserID : null,
        UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
        digitableLine: value.LINHADIGITAVEL,
        NotesJson: {
          action: "download_boleto",
          digitableLine: value.LINHADIGITAVEL || undefined,
          downloadedAt: new Date().toISOString(),
        },
      });
    },

    async sendSms(LinhaDigitavel) {
      this.loading = true;

      try {
        await this.ActionSendEmailOrSmsText({
          LinhaDigitavel,
          Email: "",
          PhoneNumber: this.user.MobileNumber
            ? this.user.MobileNumber
            : this.user.PhoneNumber,
          type: "sms",
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          IP: this.ipUser ? this.ipUser : "",
          OS: navigator.platform,
        });
        this.loading = false;

        this.flashMessage.show({
          timeout: 1000,
          blockClass: "custom-block-class",
          status: "success",
          title: "Sucesso",
          message: "Linha digitável enviado por sms com sucesso",
        });
      } catch {
        this.loading = false;
      }
    },

    async sendEmail(LinhaDigitavel) {
      this.loading = true;

      try {
        await this.ActionSendEmailOrSmsText({
          LinhaDigitavel,
          Email: this.user.Email,
          PhoneNumber: "",
          type: "email",
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          IP: this.ipUser ? this.ipUser : "",
          OS: navigator.platform,
        });
        this.loading = false;

        this.flashMessage.show({
          timeout: 1000,
          blockClass: "custom-block-class",
          status: "success",
          title: "Sucesso",
          message: "Linha digitável enviado por e-mail com sucesso",
        });
      } catch {
        this.loading = false;
      }
    },

    copiarLinhaDigitável(linhaDigitavel) {
      const elem = document.createElement("textarea");
      elem.value = linhaDigitavel;
      document.body.appendChild(elem);
      elem.select();
      document.execCommand("copy");
      document.body.removeChild(elem);

      this.ActionLogCopyDigitableLine({
        IP: this.ipUser || "",
        OS: typeof navigator !== "undefined" ? navigator.platform : "",
        UserID: this.userAdm ? this.userAdm.UserID : null,
        UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
        digitableLine: linhaDigitavel,
        NotesJson: {
          action: "copy_digitable_line",
          digitableLine: linhaDigitavel || undefined,
          copiedAt: new Date().toISOString(),
        },
      });

      this.flashMessage.show({
        timeout: 1000,
        status: "success",
        title: "Sucesso",
        blockClass: "custom-block-class",
        message: "Linha digitável foi copiada para o seu clipboard",
      });
    },

    deactivated() {
      this.divida = null;
      this.negociacao = null;
      this.selectDeal = null;
      this.digitalLine = null;
    },
    voltar() {
      this.$router.push({
        name: "negociarDivida",
        params: { contracts: this.contractFull },
      });
    },
    showDigitalLine() {
      this.digitalLine = this.selectDeal.linhaDigitavel;
    },

    selectAll() {
      var marcar = document.getElementById("all").checked;
      var lista = document.getElementsByClassName(
        "form-check-input check1 bg-primary"
      );
      for (var i = 0; i < lista.length; i++) {
        lista[i].checked = marcar;
      }
    },

    select() {
      var lista = document.getElementsByClassName(
        "form-check-input check1 bg-primary"
      );
      var all = document.getElementById("all");
      if (lista.length <= 2) {
        all.checked = false;
      }
    },

    clear() {
      var lista = document.getElementsByClassName(
        "form-check-input check1 bg-primary"
      );
      for (var i = 0; i < lista.length; i++) {
        lista[i].checked = false;
      }
    },
  },
  async created() {
    this.ipUser = localStorage.getItem("ipUser");
    this.userAdm = JSON.parse(localStorage.getItem("userAdm"));
    this.user.Menus.forEach((menuId) => {
      switch (parseInt(menuId)) {
        case 2:
          this.links.push({
            icon: "",
            text: "Contratos Negociáveis",
            route: "/dashboard/minhas-dividas",
          });
          break;
        case 1:
          this.links.push({
            icon: "",
            text: "Boletos Ativos",
            route: "meusBoletos",
          });
          break;
        case 3:
          this.links.push({
            icon: "",
            text: "Acordos",
            route: "/dashboard/meus-acordos",
          });
          break;
      }
    });
    this.loadDeal = true;
    this.responseFromAgreement = this.$route.params.responseFromAgreement;
    this.loadDeal = false;
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
  },
};
</script>
